import {
  Box,
  Button,
  DialogActions,
  TextField,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import DefaultModal from '../../components/Modals/DefaultModal';

interface ModalProps {
  open: boolean;
  setOpen: (e: boolean) => void;
  submit: (reason: string) => void;
}

const ConfirmModal = (props: ModalProps): JSX.Element => {
  const [reason, setReason] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  const handleClose = () => props.setOpen(false);

  const handleSubmit = () => {
    if (reason) {
      props.submit(reason);
      handleClose();
    } else {
      setError(true);
    }
  };

  return (
    <DefaultModal open={props.open} handleClose={handleClose}>
      <Box sx={{ px: 6 }}>
        <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
          Warning
        </Typography>
        You are about to edit a project that is already in progress. This
        project will need to be re-accepted by the freelancer. Please provide a
        reason for editing this project:
        <TextField
          sx={{ my: 2 }}
          required
          id="ReasonForEditing"
          multiline
          placeholder="Insert a reason..."
          value={reason}
          error={error}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
        />
      </Box>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button onClick={handleSubmit}>Confirm and Send</Button>
      </DialogActions>
    </DefaultModal>
  );
};

export default ConfirmModal;
